import { isAxiosError } from "axios";
import axiosInstance from "../../utility/axiosInstance";
import { toast } from "sonner";

/**
 * Approves onboarding for a CEO role.
 * @param organizationId The ID of the organization to approve.
 */
export const approveOnboardingCEO = async (
  organizationId: string,
  approved: boolean = true,
  reason: string[] = [],
) => {
  try {
    const response = await axiosInstance.post(
      `/onboarding/approve-onboarding/ceo`,
      { organizationId, approved, reason },
    );

    if (response.data.message) {
      toast.success(response.data.message);
    }

    return response.data;
  } catch (error) {
    if (isAxiosError(error)) {
      const errorMessage =
        error?.response?.data?.error?.message ||
        error?.response?.data?.message ||
        "Failed to approve onboarding as CEO";
      toast.error(errorMessage);
    }
    throw error;
  }
};

/**
 * Approves onboarding for a CTO role.
 * @param organizationId The ID of the organization to approve.
 */
export const approveOnboardingCTO = async (
  organizationId: string,
  approved: boolean = true,
  reason: string[] = [],
) => {
  try {
    const response = await axiosInstance.post(
      `/onboarding/approve-onboarding/cto`,
      { organizationId, approved, reason },
    );

    if (response.data.message) {
      toast.success(response.data.message);
    }

    return response.data;
  } catch (error) {
    if (isAxiosError(error)) {
      const errorMessage =
        error?.response?.data?.error?.message ||
        error?.response?.data?.message ||
        "Failed to approve onboarding as CTO";
      toast.error(errorMessage);
    }
    throw error;
  }
};
